import { createAction } from 'redux-api-middleware'
import type { RootState } from '../../reducers'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import ActionTypes from './actionTypes'

type PromoDeleteRequest = {
    type: typeof ActionTypes.PROMO_DELETE_REQUEST;
    payload: never;
}

type PromoDeleteFailure = {
    type: typeof ActionTypes.PROMO_DELETE_FAILURE;
    payload: Error;
}

type PromoDeleteSuccess = {
    type: typeof ActionTypes.PROMO_DELETE_SUCCESS;
    payload: number;
}

/**
 * Delete one promo given its ID
 */
function deletePromo(id: number) {
    return createAction<RootState, number, never>({
        endpoint: `${HUBBLE_API_TOKEN}/promos/${id}`,
        method: 'DELETE',
        types: [
            ActionTypes.PROMO_DELETE_REQUEST,
            {
                type: ActionTypes.PROMO_DELETE_SUCCESS,
                payload: id,
            },
            ActionTypes.PROMO_DELETE_FAILURE,
        ],
    })
}

export type PromoDeleteAction = PromoDeleteRequest
    | PromoDeleteFailure
    | PromoDeleteSuccess

export default deletePromo
